// extracted by mini-css-extract-plugin
export default {"card":"style_card__boByx","year":"style_year__2TDea","content":"style_content__A0rcI","title":"style_title__z4ROx","docs":"style_docs__h5-GN"};